import { LearnerImport } from '../models/learner-import';
import { importFileMapper } from './import-file.mapper';

/**
 * Map data to dto.
 * @param {LearnerImport} data Data
 * @returns {FormData}
 */
function toDto(data) {
  const formData = importFileMapper.toDto(data);
  if (data.checkingAssignPackageId != null) {
    formData.append('checking_assign_package_id', data.checkingAssignPackageId);
  }
  return formData;
}

export const learnerImportMapper = {
  toDto,
};
